import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { showModal, modal } from "../../modal/modalSlice";
import { ToastProps } from "../ToastManager";

export type BoardInviteToastProps = {
  boardUid: string
  ownerUid: string
  boardTitle: string
  inviteCount: number
} & ToastProps

export function BoardInviteToast({ boardUid, ownerUid, boardTitle, inviteCount, dismiss }: BoardInviteToastProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const handleClick = () => {
    dispatch(showModal(modal("boardMembers", { boardUid, ownerUid })));
    dismiss();
  };

  return (
    <div className="notification is-info" onClick={handleClick} style={{ cursor: "pointer" }}>
      <span>
        {t("toast.invite.pending-count", { count: inviteCount })} <strong>{boardTitle}</strong>
      </span>
    </div>
  );
}
